"use strict";
/* globals module */
/**
 * @module notificationsRegistrationsUsersClient
 * @description  Notifications Registrations Users Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsRegistrationsUsersClient` uses `notificationsRegistrationsUsersRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var httpApi_1 = require("../../../httpApi");
;
var _1 = require("./");
var NotificationsRegistrationsUsersClient = /** @class */ (function () {
    function NotificationsRegistrationsUsersClient(notificationsRegistrationsUsersRoute, notificationsRegistrationsUsersBatchClient, apiClient) {
        this.notificationsRegistrationsUsersRoute = notificationsRegistrationsUsersRoute;
        this.notificationsRegistrationsUsersBatchClient = notificationsRegistrationsUsersBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsRegistrationsUsersClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRegistrationsUsersRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsUsersClient.prototype, "batch", {
        get: function () {
            return this.notificationsRegistrationsUsersBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create user registration action has been performed; this action creates a new user registration resource.
     * @method
     * @param data An UserRegistration object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user registration action has been performed.
     * @example notificationsRegistrationsUsersClient.create({
                    provider: '<provider-name>',
                    providerData: <provider-data>,
                    userId: '<user-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsRegistrationsUsersClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user registrations resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example notificationsRegistrationsUsersClient.find({
                   pageNumber : 1,
                   pageSize : 10,
                   orderBy : '<field>',
                   orderDirection : '<asc|desc>',
                   search : '<search-phrase>',
                   providers: '<provider-name1>,<provider-name2>',
                   userIds: '<user-id1>,<user-id2>',
                   embed: '<embed>'
               })
               .then(function (collection) {
                   // perform success action here
               },
                function (response, status, headers, config) {
                    // perform error handling here
               });
    */
    NotificationsRegistrationsUsersClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified user registrations resource.
     * @method
     * @param id The registration identifier which uniquely identifies UserRegistration resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example notificationsRegistrationsUsersClient.get('<registration-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    */
    NotificationsRegistrationsUsersClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.notificationsRegistrationsUsersRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the remove user registrations action has been performed. This action will remove a user registrations resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsRegistrationsUsersRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(registration);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An object used to delete specified UserRegistration resource.
     * @example // registration is a resource previously fetched using get action.
                    notificationsRegistrationsUsersClient.remove(registration)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsRegistrationsUsersClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update user registration action has been performed; this action updates a user registration resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsRegistrationsUsersRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(subsregistrationcription);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An object used to update specified UserRegistration resource.
     * @returns A promise that is resolved once the update user registration action has been performed.
     * @example // registration is a resource previously fetched using get action.
                    registration.provider = '<provider-name>';
                    notificationsRegistrationsUsersClient.update(registration)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsRegistrationsUsersClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b, _c;
    NotificationsRegistrationsUsersClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsRegistrationsUsersRoute !== "undefined" && _1.NotificationsRegistrationsUsersRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsUsersBatchClient !== "undefined" && _1.NotificationsRegistrationsUsersBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], NotificationsRegistrationsUsersClient);
    return NotificationsRegistrationsUsersClient;
}());
exports.NotificationsRegistrationsUsersClient = NotificationsRegistrationsUsersClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
